module.exports = __webpack_public_path__ + "media/images/countryrect/rs-e159ddf61c7b1d899e1ff051088eef37.svg";